import { useState, useCallback } from 'react';
import { useDebounce } from '../../../../../lib/hooks/useDebounce';
import type { TeamCompleationTrainingQueryParams } from '../../../../../apiHooks/useManagerTeamCompleationQuery';

export const useTeamTrainingCompleationFilters = (
  onNewParams: (params: Partial<TeamCompleationTrainingQueryParams>) => void,
) => {
  const [nameSearchInputValue, setNameSearchInputValue] = useState<string>('');
  const debounceOnNewParams = useDebounce(onNewParams, 300);

  const handleNameSearchChange = useCallback(
    (searchTerm: string) => {
      setNameSearchInputValue(searchTerm);
      const newFilters = searchTerm ? searchTerm : '';
      debounceOnNewParams({ nameFilter: newFilters });
    },
    [debounceOnNewParams],
  );

  const clearFilters = useCallback(() => {
    setNameSearchInputValue('');
    onNewParams({ nameFilter: '' });
  }, [onNewParams]);

  return { nameSearchInputValue, handleNameSearchChange, clearFilters };
};
